var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarLeadArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#2E2D79",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.028.333c9.294 1.314 15.294 7.447 18 18.4M11.229 15.953L18.206 19.428 22.429 11.828",
    transform: "translate(-225 -1312) rotate(7 -10616.855 2522.709)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarLeadArrowRight);
export default __webpack_public_path__ + "static/media/car-lead-arrow-right.14b98f42a3cf4cd346bc29f846fedae8.svg";
export { ForwardRef as ReactComponent };